import React, { useEffect, useState } from 'react';

const STAGES = {
  loading: { en: 'Loading…', ru: 'Загрузка…' },
  almost: { en: 'Almost ready', ru: 'Почти готово' },
};

// Same progress bar the splash screen uses, for sections that need a
// moment to fetch their data. `progress` is the real share of finished
// requests (0-100); the displayed value eases towards it and creeps
// slowly so the bar never looks frozen.
export const SectionLoader = ({ progress = 0, language, label }) => {
  const [shown, setShown] = useState(0);
  const key = language === 'ru' ? 'ru' : 'en';

  useEffect(() => {
    const id = setInterval(() => {
      setShown((prev) => {
        if (progress >= 100) return Math.min(100, prev + Math.max(2, (100 - prev) * 0.3));
        const ceiling = Math.min(96, progress + 10);
        if (prev < progress) return Math.min(progress, prev + Math.max(1, (progress - prev) * 0.16));
        return Math.min(ceiling, prev + 0.4);
      });
    }, 50);
    return () => clearInterval(id);
  }, [progress]);

  const pct = Math.round(shown);
  const stage = pct > 70 ? STAGES.almost[key] : STAGES.loading[key];

  return (
    <div className="flex flex-col items-center justify-center min-h-[55vh] px-10" data-testid="section-loader">
      <div className="w-full max-w-[220px]">
        <div className="h-[3px] rounded-full bg-white/[0.07] overflow-hidden">
          <div
            className="h-full rounded-full transition-[width] duration-200 ease-out"
            style={{
              width: `${pct}%`,
              background: 'linear-gradient(90deg, #8A6B22 0%, #C4A052 55%, #F0D9A0 100%)',
              boxShadow: '0 0 12px rgba(196,160,82,0.65)',
            }}
            data-testid="section-loader-bar"
          />
        </div>
        <div className="mt-3 flex items-center justify-between">
          <span className="text-xs tracking-wide text-white/45" data-testid="section-loader-label">
            {label || stage}
          </span>
          <span className="text-xs tabular-nums text-[#C4A052]/90" data-testid="section-loader-percent">
            {pct}%
          </span>
        </div>
      </div>
    </div>
  );
};

export default SectionLoader;
